import { http } from "@/config/httpCommon";

export default {
  state: {
    stripe_tax_code: [],
    stripe_integration: [],
    stripe_payment_type: [],
    
  },

  mutations: {
    set(state, [variable, value]) {
      state[variable] = value;
    },
  },

  getters: {
    getStripeTaxCode(state) {
      return state.stripe_tax_code;
    },
    getStripeIntegration(state) {
      return state.stripe_integration;
    },
     getStripePaymentTypes(state) {
      return state.stripe_payment_type;
    },
  },

  actions: {
    async getStripeTaxCodeAndIntegration({ commit }) {
      const res = await http.get("stripe/configuration-constants");
      console.log('res,res',res)
      commit("set", ["stripe_tax_code", res.data.result.stripeTaxCode]);
      commit("set", ["stripe_payment_type", res.data.result.stripePaymentType]);
      commit("set", ["stripe_integration", res.data.result.integration]);
      return res;
    },

  }
};
